/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 给项目写评论
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  projectCommentDTO: member.ProjectCommentDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.ProductCommentDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/comment`,
    data: projectCommentDTO,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
